import * as Colors from '../colors';

export default {
  inputRoot: {
    '&[class*="MuiOutlinedInput-root"]': {
      padding: '0px 4.5px',
    },
  },
  option: {
    '&[data-focus="true"]': {
      backgroundColor: Colors.HoverNonBorderBackground,
    },
  },
};
